let stepsApi = {
    cimcal: {
        async getCodPraca(companyId, token){
            return await window.axios.get('/proxy/cimcal/locations', {
                params: {
                    api_token: token,
                    company_id: companyId,
                }
            })
        },
        async getCityList(companyId, token){
            return await window.axios.get('/proxy/cimcal/cities', {
                params: {
                    api_token: token,
                    company_id: companyId,
                }
            })
        }
    }
}

export default stepsApi